export const version = {
  timeStamp: '2026-07-22 08:19:37 AM ',
  version: '0.0.5',
};
